import { Injectable } from '@angular/core';
import {Subject, ReplaySubject} from 'rxjs';

import {CollegeSummary} from "../shared/programmapper-authoring.model";
import {LocalStorageService} from "ngx-webstorage";
import {AccountService} from "./account/account.service";

declare global {
  interface Window { Appcues: any; }
}

@Injectable({
  providedIn: 'root'
})

export class SelectedCollegeService {
  college$: Subject<CollegeSummary> = new ReplaySubject(1);
  selectedCollegeId: string;
  selectedCollegeName: string;

  constructor(private localStorageService: LocalStorageService,
  private accountService: AccountService
) {}

  selectCollege(college: CollegeSummary) : boolean {
    if (college) {
      this.localStorageService.store('preferredCollegeId', college.id);
      this.selectedCollegeId = college.id;
      this.selectedCollegeName = college.name;
      this.college$.next(college);

      const currentUser$ = this.accountService.getCurrentUser();

      currentUser$.subscribe(value => {
        if (value !== null) {
          const userProperties = {
            email: value.email,
            userOrganization: college.id
          };

          if (window.Appcues) {
            window.Appcues.identify(value.email, userProperties);
          }
        }
      });


      return true;
    }
    else{
      this.selectedCollegeId = undefined;
      this.college$.next(undefined);
      return false;
    }
  }

  getPreferredCollegeId(): string{
    return this.localStorageService.retrieve('preferredCollegeId');
  }

  getSelectedCollegeId() {
    return this.selectedCollegeId;
  }

  clearCollege() {
    this.selectCollege(undefined);
  }

  clearPreferredCollegeId() {
    this.localStorageService.clear('preferredCollegeId');
  }
}
